<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i> Export</b-button>
        </div>
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-2" @click="add">Add</b-button>
        </div>
      </div>
      <b-row>
        <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend>
              <label>Kode</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.marital_status_code" placeholder=""></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend>
              <label>Nama</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.marital_status_name"></b-form-input>
            <b-input-group-append>
              <b-button class="btn btn-success ml-3" @click="refresh()">
                <i class="fa fa-refresh"></i> Apply
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table class="mb-0" ref="table" outlined responsive striped hover small style="font-size:smaller;" :items="data"
        :fields="tblFields" :current-page="tblData.page" :per-page="tblData.limit" :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc" :key="tblData.limit" @row-clicked="rowClicked" show-empty :busy="isBusy">
        <template v-slot:cell(index)="data">{{ ((tblData.page - 1) * tblData.limit) + (data.index + 1) }}</template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
        <template v-slot:cell(action)="data">
          <div class="text-center">
            <a href="javascript:void(0)" @click.stop="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
              <i class="fa fa-trash"></i>
            </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="((tblData.page * tblData.limit) > tblData.total)">{{ tblData.total }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total | numFormat }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top:0 !important;">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit" size="sm"
                  style="width:80px" />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit" v-model="tblData.page">
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
toastr.init();
export default {
  components: { Loading },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      isLoading: false,
      showDelConfirm: false,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "marital_status_code",
        sortDesc: false,
        tablename: 'maritalstatus',
        marital_status_code: '',
        marital_status_name: ''
      },
      dataList: {
        debiturStatus: dropdown.debiturStatus
      },
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "No.",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "marital_status_code",
          label: "Code",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "marital_status_name",
          label: "Name",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "action",
          label: "-",
          thClass: "text-center",
        },
      ];
      return fields;
    },
  },
  methods: {
    async adddebitur() {
      router.push({ name: "loan.master-debitur-form" });
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = 'info';
      this.$forceUpdate();
      // }
    },
    async data() {
      try {
        this.isBusy = true;
        const filter = this.$store.state.filter;
        let filtered = false;
        for (var key in filter.debiturList) {
          this.tblData[key] = filter.debiturList[key];
          filtered = true;
        }
        if (filtered === true) {
          this.showFilter = filtered;
          delete filter.debiturList;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        const searchkey = ['marital_status_code', 'marital_status_name'];
        this.tblData.customQuery = '';
        searchkey.map(key => {
          if (this.tblData[key]) {
            this.tblData.customQuery += this.tblData.customQuery ? "&" : "?";
            this.tblData.customQuery = `${key} =${encodeURIComponent((this.tblData[key]).trim())}`;
          }
        });
        const list = await crud.list(this.tblData);
        this.isBusy = false;
        return list;
      } catch (error) {
        this.isBusy = true;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async edit(model) {
      if (model.marital_status_code && model.marital_status_code !== "undefined") {
        const filter = this.$store.state.filter;
        this.$store.commit("filter", filter);
        router.push({
          name: "master.maritalstatusform",
          params: { marital_status_code: model.marital_status_code },
        });
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    add: function() {
          router.push({name :'master.maritalstatusform'});
    },
    deleteConfirm(item) {
      this.rowClicked(item);
      this.showDelConfirm = true;
    },
    deleteData: async function () {
      try {
        this.isLoading=true;
        await crud.remove({
          tablename: this.tblData.tablename, 
          key: this.model.marital_status_code, 
        });
        this.isLoading=false;
        this.refresh(); 
      } catch (error) {
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async importCollectorToDebiturXls() {
      router.push({ name: 'loan.importDataCollectorToDebitur' });
    },
    async exportxls() {
      try {
        await crud.exportxls(this.tblData);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },

    async refresh() {
      try {
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData = {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "marital_status_code",
        sortDesc: false,
        tablename: 'maritalstatus',
        marital_status_code: '',
        marital_status_name: ''
      };
      this.refresh();
    },

    close() {
      router.push({ name: "paylater.home" });
    }
  }
};
</script>